import React, { useEffect } from "react";
import "@geoapify/geocoder-autocomplete/styles/minimal.css";
import PropTypes from "prop-types";
import { GeocoderAutocomplete } from "@geoapify/geocoder-autocomplete";

function LocationAutocomplete(props) {
  const { idAndClassName, locationValue, setLocationValue } = props;

  useEffect(() => {
    const autocomplete = new GeocoderAutocomplete(
        document.getElementById(idAndClassName),
        "771f07f730d1459c948214a6a5acb2fe",
        {
          skipIcons: true,
        },
        { /* Geocoder options */ });

    autocomplete.on("select", (location) => {
      if (location == null) {
        setLocationValue("");
        return;
      }
      if (location.properties.formatted) {
        setLocationValue(location.properties.formatted.toString());
      } else {
        console.log("Our API doesn't like your address... But we'll take it anyways.");
        let fallback = document.getElementById(idAndClassName).getElementsByTagName("input")[0].value;
        setLocationValue(fallback);
      }
    });

    // autocomplete.setType("city");

    autocomplete.setValue(locationValue);
  }, []);

  useEffect(() => {
    console.log(locationValue);
  }, [locationValue]);

  return (
    <div id={idAndClassName} className= {idAndClassName + " relative border border-gray-300 bg-white w-96 rounded-sm mr-4 mb-4 [&>input]:text-base [&>div]:mb-0 [&>input]:h-10 [&>input]:rounded-xl [&>input]:mb-0 [&>input]:border-none w-full"} />
  );
};

LocationAutocomplete.propTypes = {
  idAndClassName: PropTypes.string.isRequired,
  locationValue: PropTypes.string,
  setLocationValue: PropTypes.func,
};

LocationAutocomplete.defaultProps = {
  idAndClassName: "",
  locationValue: "",
  setLocationValue: () => { },
};

export default LocationAutocomplete;
